import Toastr from '../../../components/Toastr'

const parent = 'SETTING_'

const DEFAULT_STATE = {
  warehouses: [],
  warehouse: {},
  warehouse_inventories: [],
  filterOptions: {},
  transfers: [],
  transfer: null,
  transferStore: null,
  pendingTransferStores: [],
  pendingTransferMeta: { pagination: {} },
  inventoryMeta: { pagination: {} },
  transferMeta: { pagination: {} },
  meta: { pagination: {} },
  saving: false
}

const pickTransfer = (response = {}) => (
  response.transfer
  || response.inventory_transfer
  || (response.id && (response.transfer_stores_attributes || response.transfer_stores || response.status) ? response : null)
)

let changes = null

export default function warehouseReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let warehouses = []
  let warehouseData = []
  let updatedRecord = {}

  switch (action.type) {
    case `${parent}WAREHOUSES_LOAD_PENDING`:
    case `${parent}WAREHOUSE_LOAD_PENDING`:
    case `${parent}WAREHOUSE_INVENTORIES_LOAD_PENDING`:
    case `${parent}INVENTORY_TRANSFERS_LOAD_PENDING`:
    case `${parent}TRANSFER_STORE_LOAD_PENDING`:
    case `${parent}TRANSFER_STORE_START_COUNT_PENDING`:
      return { ...state, saving: true }
    case `${parent}PENDING_TRANSFER_STORES_LOAD_PENDING`:
      return {
        ...state,
        saving: true,
        pendingTransferStores: [],
        pendingTransferMeta: { pagination: {} },
      }
    case `${parent}TRANSFER_STORE_SCAN_PENDING`:
    case `${parent}TRANSFER_STORE_SAVE_COUNT_PENDING`:
    case `${parent}TRANSFER_STORE_POST_COUNT_PENDING`:
    case `${parent}TRANSFER_STORE_CREATE_RETURN_PENDING`:
    case `${parent}TRANSFER_STORE_POST_RECEIPT_PENDING`:
      return { ...state, saving: false }

    case `${parent}WAREHOUSE_CREATE_PENDING`:
    case `${parent}WAREHOUSE_UPDATE_PENDING`:
    case `${parent}WAREHOUSE_INVENTORY_CREATE_PENDING`:
    case `${parent}INVENTORY_TRANSFER_CREATE_PENDING`:
    case `${parent}INVENTORY_TRANSFER_UPDATE_PENDING`:
    case `${parent}INVENTORY_TRANSFER_DELETE_PENDING`:
      return { ...state, saving: true }

    case `${parent}WAREHOUSES_LOAD_REJECTED`:
    case `${parent}WAREHOUSE_LOAD_REJECTED`:
    case `${parent}WAREHOUSE_INVENTORIES_LOAD_REJECTED`:
    case `${parent}INVENTORY_TRANSFERS_LOAD_REJECTED`:
    case `${parent}INVENTORY_TRANSFER_LOAD_REJECTED`:
    case `${parent}PENDING_TRANSFER_STORES_LOAD_REJECTED`:
    case `${parent}TRANSFER_STORE_LOAD_REJECTED`:
    case `${parent}TRANSFER_STORE_START_COUNT_REJECTED`:
    case `${parent}TRANSFER_STORE_SCAN_REJECTED`:
    case `${parent}TRANSFER_STORE_SAVE_COUNT_REJECTED`:
    case `${parent}TRANSFER_STORE_POST_COUNT_REJECTED`:
    case `${parent}TRANSFER_STORE_CREATE_RETURN_REJECTED`:
    case `${parent}TRANSFER_STORE_POST_RECEIPT_REJECTED`:
    case `${parent}WAREHOUSE_CREATE_REJECTED`:
    case `${parent}WAREHOUSE_UPDATE_REJECTED`:
    case `${parent}WAREHOUSE_DELETE_REJECTED`:
    case `${parent}WAREHOUSE_INVENTORY_CREATE_REJECTED`:
    case `${parent}INVENTORY_TRANSFER_CREATE_REJECTED`:
    case `${parent}INVENTORY_TRANSFER_UPDATE_REJECTED`:
    case `${parent}INVENTORY_TRANSFER_DELETE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = { saving: false }
      return { ...state, ...changes }

    case `${parent}WAREHOUSES_LOAD_FULFILLED`:
      changes = {
        warehouses: response.warehouses || response.inventory_warehouses || [],
        meta: response.meta || { pagination: {} },
        saving: false
      }
      return { ...state, ...changes }

    case `${parent}WAREHOUSE_INVENTORIES_LOAD_FULFILLED`:
      changes = {
        warehouse_inventories: response.warehouse_inventories || [],
        inventoryMeta: response.meta || { pagination: {} },
        saving: false
      }
      return { ...state, ...changes }

    case `${parent}FILTER_OPTIONS_LOAD_PENDING`:
      return { ...state, filterOptions: {} }

    case `${parent}FILTER_OPTIONS_LOAD_REJECTED`:
      return { ...state, filterOptions: {}, saving: false }

    case `${parent}FILTER_OPTIONS_LOAD_FULFILLED`:
      return {
        ...state,
        filterOptions: response.filters || {},
        saving: false,
      }

    case `${parent}INVENTORY_TRANSFERS_LOAD_FULFILLED`:
      changes = {
        transfers: response.transfers || response.inventory_transfers || [],
        transferMeta: response.meta || { pagination: {} },
        saving: false
      }
      return { ...state, ...changes }

    case `${parent}INVENTORY_TRANSFER_LOAD_FULFILLED`: {
      const loaded = pickTransfer(response)
      return {
        ...state,
        transfer: loaded
          ? { ...loaded, summary: response.meta?.summary || {} }
          : null,
        saving: false,
      }
    }

    case `${parent}INVENTORY_TRANSFER_CLEAR`:
      return { ...state, transfer: null }

    case `${parent}TRANSFER_STORE_CLEAR`:
      return { ...state, transferStore: null }

    case `${parent}PENDING_TRANSFER_STORES_LOAD_FULFILLED`:
      changes = {
        pendingTransferStores: response.transfer_stores || response.inventory_transfer_stores || [],
        pendingTransferMeta: response.meta || { pagination: {} },
        saving: false
      }
      return { ...state, ...changes }

    case `${parent}TRANSFER_STORE_LOAD_FULFILLED`:
    case `${parent}TRANSFER_STORE_START_COUNT_FULFILLED`:
    case `${parent}TRANSFER_STORE_SAVE_COUNT_FULFILLED`:
    case `${parent}TRANSFER_STORE_POST_COUNT_FULFILLED`:
    case `${parent}TRANSFER_STORE_SCAN_FULFILLED`: {
      const loadedStore = response.transfer_store
      if (!loadedStore) return { ...state, saving: false }
      const nextSummary = response.meta?.summary != null
        ? response.meta.summary
        : (state.transferStore?.summary || {})
      if (action.type === `${parent}TRANSFER_STORE_START_COUNT_FULFILLED`) {
        Toastr.handleShow(true, response.meta?.message || 'Physical count started', 201)
      }
      if (action.type === `${parent}TRANSFER_STORE_SAVE_COUNT_FULFILLED`) {
        Toastr.handleShow(true, response.meta?.message || 'Physical count saved', 200)
      }
      if (action.type === `${parent}TRANSFER_STORE_POST_COUNT_FULFILLED`) {
        Toastr.handleShow(true, response.meta?.message || 'Physical count posted', 200)
      }
      return {
        ...state,
        transferStore: { ...loadedStore, summary: nextSummary },
        saving: false,
      }
    }

    case `${parent}TRANSFER_STORE_CREATE_RETURN_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message || 'Return transfer created', 201)
      return { ...state, saving: false }

    case `${parent}TRANSFER_STORE_POST_RECEIPT_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message || 'Receipt posted successfully', 201)
      return { ...state, saving: false }

    case `${parent}WAREHOUSE_INVENTORY_CREATE_FULFILLED`:
      return { ...state, saving: false }

    case `${parent}INVENTORY_TRANSFER_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message || 'Inventory Transfer created', 201)
      return { ...state, saving: false }

    case `${parent}INVENTORY_TRANSFER_UPDATE_FULFILLED`: {
      Toastr.handleShow(true, response.meta?.message || 'Inventory Transfer updated', 201)
      const updatedTransfer = response.transfer || response.inventory_transfer
      if (!updatedTransfer?.id) return { ...state, saving: false }
      return {
        ...state,
        saving: false,
        transfers: (state.transfers || []).map(item => (
          String(item.id) === String(updatedTransfer.id) ? { ...item, ...updatedTransfer } : item
        )),
      }
    }

    case `${parent}INVENTORY_TRANSFER_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message || 'Inventory Transfer deleted', 201)
      return { ...state, saving: false }

    case `${parent}WAREHOUSE_LOAD_FULFILLED`:
      changes = {
        warehouse: response.warehouse || response.inventory_warehouse || {},
        saving: false
      }
      return { ...state, ...changes }

    case `${parent}WAREHOUSE_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      warehouses = [...state.warehouses]
      changes = {
        warehouses: [...warehouses, response.warehouse || response.inventory_warehouse],
        editing: false,
        saving: false
      }
      return { ...state, ...changes }

    case `${parent}WAREHOUSE_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      warehouses = [...state.warehouses]
      updatedRecord = response.warehouse || response.inventory_warehouse
      for (const [index, warehouse] of warehouses.entries()) {
        if (warehouse.id === updatedRecord.id) {
          warehouseData = [
            ...warehouses.slice(0, index),
            updatedRecord,
            ...warehouses.slice(index + 1)
          ]
        }
      }
      changes = {
        warehouses: warehouseData,
        editing: false,
        saving: false
      }
      return { ...state, ...changes }

    case `${parent}WAREHOUSE_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      warehouses = [...state.warehouses]
      const deletedId = response.warehouse?.id || action.payload.id
      for (const [index, warehouse] of warehouses.entries()) {
        if (warehouse.id === deletedId) {
          warehouses.splice(index, 1)
        }
      }
      return {
        ...state,
        warehouses
      }

    case `${parent}WAREHOUSE_EDIT`:
      changes = {
        editing: { id: action.id },
        warehouse: action.id === 'New'
          ? DEFAULT_STATE.warehouse
          : (action.warehouse || state.warehouse),
      }
      return { ...state, ...changes }

    case `${parent}WAREHOUSE_EDIT_CANCEL`:
      changes = {
        editing: false,
        warehouse: DEFAULT_STATE.warehouse
      }
      return { ...state, ...changes }

    default:
      return state
  }
}
